<template>
  <footer class="footer">
    <div class="container text-center">
      <!-- <nav> -->
        <!-- <ul class="footer-menu text-center"> -->
          <!-- <li> -->

        <p class="NeedHelp" @click="Send()">Need help? <span class="text-primary">Click Here</span>.</p> 
          <!-- </li> -->
        <!-- </ul> -->
      <!-- </nav> -->
      <div class="copyright text-center">
        <!-- &copy; Coded with -->
        <!-- <i class="fa fa-heart heart"></i> by -->
        <!-- <a href="https://binarcode.com" target="_blank">BinarCode</a>. -->
        <!-- Designed by <a href="https://www.creative-tim.com/?ref=pdf-vuejs" target="_blank">Creative Tim</a>. -->
      </div>
    </div>

  </footer>
</template>

<script>

  import { globalStore } from '../main.js';
  import { db } from '../main.js';
  import $ from 'jquery';
  import moment from 'moment';
  import axios from 'axios';
  import swal from 'sweetalert';

  export default {
    data(){
      return{

      }
    },
    mounted(){
      console.log("Footer Mounted");
    },
    methods:{
      Send(){
        console.log("Test");

        swal({
          button: "Send",
          content: {
            element: "input",
            attributes: {
              placeholder: "What problem are you facing?",
              type: "text",
            },
          },
        })
        .then((res) => {
            console.log(res)

                if(res){

                  var sub = "Need Help - "+globalStore.UserInfo.CompanyName
                  var msg = "Trigger: Admin panel > footer > Need Help<br>From: "+globalStore.UserInfo.Email+"<br>Company: "+globalStore.UserInfo.CompanyName+"<br><br>Messge:<br>"+res+"<br><br>Cheers,<br>Team Visity";

                  var info = {
                    Subject: sub,
                    Message: msg
                  };

                  console.log("Email Payload: "+JSON.stringify(info, null, 2));
     
                      // // Send Email
                      axios.post("https://us-central1-visity-usa.cloudfunctions.net/widgets/upgrade-request", info).then((res) => {
                        console.log(res);
                        var response = res;
                      }).catch((e) => {
                        console.log(e);
                      });            
                  
                }



        });

      }
    }
  }



</script>
<style>

  
  .NeedHelp{
    font-size: 0.9em;
    cursor: pointer;
  }

</style>
